module.exports = __webpack_public_path__ + "static/media/company-graph.07aa732c.png";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/company-graph.png
// module id = 299
// module chunks = 0